import { ElementComponents } from '@/components/sections/builder/builder-element';
import { ElementType, ThemeType } from '@/stores/builder';

export default function BodyElements({
  elements,
  group,
  theme,
  data,
  isLoading,
}: {
  elements: ElementType[];
  group: string;
  theme?: ThemeType;
  data?: unknown;
  isLoading?: boolean;
}) {
  const bodyGroups = group.split(',');
  const bodyElements = elements?.filter((element) => bodyGroups.includes(element.group));
  return (
    <div className='theme_layout_space_section flex-grow'>
      {bodyElements.map((element) => {
        const Element = ElementComponents[element.type].Element;
        if (Element)
          return (
            <Element
              element={element}
              key={element.id}
              theme={theme}
              data={data}
              isLoadingData={isLoading}
            />
          );
      })}
    </div>
  );
}
